export default "__VITE_ASSET__DHYBJcvq__"